"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kbd = exports.useKbd = exports.ctx = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const keyboard_1 = require("@jsonjoy.com/keyboard");
exports.ctx = React.createContext(null);
const useKbd = () => {
    const kbd0 = React.useContext(exports.ctx);
    const disposeRef = React.useRef(void 0);
    const kbd1 = React.useMemo(() => {
        if (kbd0)
            return kbd0;
        const [kbd, dispose] = keyboard_1.KeyContext.global();
        disposeRef.current = dispose;
        return kbd;
    }, [kbd0]);
    React.useEffect(() => {
        return () => {
            disposeRef.current?.();
        };
    }, []);
    return kbd1;
};
exports.useKbd = useKbd;
const Kbd = ({ child, bind, children }) => {
    const kbd0 = (0, exports.useKbd)();
    const kbd1 = React.useMemo(() => {
        return child ? kbd0.child(child) : kbd0;
    }, [kbd0, child]);
    React.useEffect(() => {
        return () => {
            if (kbd0 !== kbd1)
                kbd1.dispose();
        };
    }, [kbd1, kbd0]);
    React.useEffect(() => {
        if (!bind)
            return;
        const unbind = kbd1.bind(bind);
        return () => {
            unbind();
        };
    }, [kbd1.bind, bind]);
    return React.createElement(exports.ctx.Provider, { value: kbd1 }, children);
};
exports.Kbd = Kbd;
